module.exports = __webpack_public_path__ + "img/home_spaceman_img.fe06a2d9.png";